import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {FormsModule} from '@angular/forms';
import {IconComponent} from '../../icon/icon.component';
import {ThemeEnum} from '../../../enums/theme.enum';
import {Icon} from '../../../types/icons/icon.type';
import {ICONS} from '../../../constants/icons/icons.constants';
import {ButtonComponent} from '../../buttons/button/button.component';
import {ButtonTypeEnum} from '../../../enums/button/button-type.enum';
import {AppButtonTypeEnum} from '../../../enums/button/app-button-type.enum';
import {ButtonColorEnum} from '../../../enums/button/button-color.enum';
import {KeyValuePipe} from '@angular/common';
import {AppDialogModal} from '../../../models/modal/dialog/app-dialog-modal.model';
import {APP_MODAL_REF} from '../../../constants/modal/app-modal-ref.constant';
import {ModalService} from '../../../services/modal/modal.service';
import {AppThemeSelectionDialogData} from '../../../types/modal/dialog/app-theme-selelction-dialog-data.type';
import {SelectionFormItemComponent} from '../../form-elements/selection-form-item/selection-form-item.component';
import {AppIconSizeEnum} from '../../../enums/app-icon-size.enum';

@Component({
    selector: 'app-theme-selection-dialog',
    templateUrl: './theme-selection-dialog.component.html',
    styleUrls: ['./theme-selection-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TranslateModule,
        FormsModule,
        IconComponent,
        ButtonComponent,
        KeyValuePipe,
        SelectionFormItemComponent
    ]
})
export class ThemeSelectionDialogComponent {
    public readonly modalData: AppThemeSelectionDialogData;
    protected readonly themeIcons: Record<ThemeEnum, Icon> = {
        [ThemeEnum.SYSTEM]: ICONS.LIGHT_DARK_MODE,
        [ThemeEnum.LIGHT]: ICONS.LIGHT_MODE,
        [ThemeEnum.DARK]: ICONS.DARK_MODE,
    };
    protected selectedTheme: string;
    protected readonly ButtonTypeEnum = ButtonTypeEnum;
    protected readonly AppButtonTypeEnum = AppButtonTypeEnum;
    protected readonly ButtonColorEnum = ButtonColorEnum;
    protected readonly qaTag: string;
    protected readonly AppIconSizeEnum = AppIconSizeEnum;
    private readonly modalService = inject(ModalService);
    private readonly modalRef = inject<AppDialogModal<ThemeSelectionDialogComponent, AppThemeSelectionDialogData, ThemeEnum>>(APP_MODAL_REF);

    public constructor() {
        this.modalData = this.modalRef.modalData;
        this.selectedTheme = this.modalData.currentTheme as string;
        this.qaTag = this.modalRef.qaTag;
    }

    protected confirm(): void {
        this.modalService.closeModal(this.modalRef, this.selectedTheme);
    }

    protected cancel(): void {
        this.modalService.closeModal(this.modalRef);
    }
}
